import React, { useEffect, useState } from "react";
import { Card, Row, Col, Spinner, Table } from "react-bootstrap";
import API from "../api/api";

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        setLoading(true);
        const res = await API.get("/api/admin/dashboard", {
          withCredentials: true,
        });
        if (res.data.success) setData(res.data);
      } catch (err) {
        console.error("Error fetching dashboard:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchDashboard();
  }, []);

  if (loading || !data)
    return (
      <div className="text-center my-5">
        <Spinner animation="border" />
      </div>
    );

  const {
    usersCount,
    ordersCount,
    earningsCount,
    encashmentsCount,
    encashmentsPayment,
  } = data;

  const renderTable = (title, items) => (
    <Card className="shadow-sm mb-3">
      <Card.Header>{title}</Card.Header>
      <Card.Body>
        <Table responsive bordered hover size="sm">
          <thead>
            <tr className="text-center">
              <th>Type</th>
              <th>Count</th>
              <th>Total (Rs.)</th>
            </tr>
          </thead>
          <tbody>
            {items.map((i, idx) => (
              <tr key={idx} className="text-center">
                <td>{i._id}</td>
                <td>{i.count}</td>
                <td>{i.total || "-"}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Admin Dashboard</h3>

      {/* Quick Stats */}
      <Row className="mb-4">
        <Col md={3}>
          <Card className="shadow-sm text-center p-3">
            <h6>Total Users</h6>
            <h4>{usersCount.reduce((a, b) => a + b.count, 0)}</h4>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="shadow-sm text-center p-3">
            <h6>Total Orders</h6>
            <h4>{ordersCount.reduce((a, b) => a + b.count, 0)}</h4>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="shadow-sm text-center p-3">
            <h6>Total Earnings (Rs.)</h6>
            <h4>{earningsCount.reduce((a, b) => a + (b.total || 0), 0)}</h4>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="shadow-sm text-center p-3">
            <h6>Encashments Requested</h6>
            <h4>{encashmentsCount.reduce((a, b) => a + b.count, 0)}</h4>
          </Card>
        </Col>
      </Row>

      {/* Breakdown Tables */}
      {renderTable("Users by Role", usersCount)}
      {renderTable("Orders by Status", ordersCount)}
      {renderTable("Earnings by Status", earningsCount)}
      {renderTable("Encashments by Status", encashmentsCount)}
      {renderTable("Encashments by Payment", encashmentsPayment)}
    </div>
  );
}
